import { computed, ComputedRef } from 'vue';
import { useStore } from 'vuex';

import { getAccountRouteHandler, IGetAccountRouteHandler } from '@/bundles/App/helpers/accountRoute';

interface IAccountRouteTarget {
  name: string;
  params?: Record<string, any>;
  query?: Record<string, any>;
}

interface IUseAccountRoute {
  activeAccountId: ComputedRef<number | undefined>;
  getAccountRoute: (target: IAccountRouteTarget) => IGetAccountRouteHandler;
}

/**
 * The `<script setup>` counterpart of `AccountLayoutMixin.getAccountRoute`:
 * every in-app route target goes through it so the active account stays in
 * the URL. Use the result for `router.push(...)` and `:to`.
 */
export const useAccountRoute = (): IUseAccountRoute => {
  const store = useStore();

  const activeAccountId = computed<number | undefined>(() => store.state.activeAccount?.id);

  const getAccountRoute = ({ name, params = {}, query = {} }: IAccountRouteTarget): IGetAccountRouteHandler => getAccountRouteHandler({
    name,
    params,
    query,
    activeAccountId: activeAccountId.value,
  });

  return { activeAccountId, getAccountRoute };
};
